import { useState, useEffect } from 'react';
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../components/TitlePage/TitlePage';
import { ModalMiltilevelSidebarSettings } from '../../../components/Modal/ModalMiltilevelSidebarSettings/ModalMiltilevelSidebarSettings';
import './ModalTransferFile.scss'

const ModalTransferFile = ({ setIsModal }) => {

    const [selectedTopLevelValue, setSelectedTopLevelValue] = useState(0);
    const [selectedEndLevelValue, setSelectedEndLevelValue] = useState(0);
    const [selectedItemId, setSelectedItemId] = useState(null);

    return (
        <div className='blackout' onClick={(e) => {
            let el = e.target
            if (el.classList.contains('blackout')) {
                setIsModal(false)
            }
        }}>
            <div className='modal-transfer-file'>
                <TitlePage
                    title='Выберите папку для переноса файлов'
                />

                <div className='modal-transfer-file__content'>
                    <ModalMiltilevelSidebarSettings
                        directory={true}
                        onPortalClick={(id) => {
                            setSelectedTopLevelValue(id);
                            setSelectedEndLevelValue(null);
                        }}
                        selectedItemId={selectedItemId}
                        setSelectedItemId={setSelectedItemId}
                        readonly={true}
                        stopRedirect
                    />
                </div>

                <div className='modal-transfer-file__btn-group'>
                    <ButtonBasic
                        grey
                        text='Отмена'
                        width='calc(50% - 6px)'
                        onClick={(e) => {
                            setIsModal(false)
                        }}
                    />
                    <ButtonBasic
                        disabled={!selectedItemId}
                        blue
                        text='Выбрать'
                        width='calc(50% - 6px)'
                        onClick={(e) => setIsModal(false)}
                    />
                </div>
            </div>
        </div>
    )
}

export { ModalTransferFile }